import React, {useRef, useState} from "react"
import productPageImg from "../../../../../assets/website-images/product/iam/iam-product-img.png"
import productBannerImg from "../../../../../assets/website-images/product/product-banner.jpg";
import {useInView} from "framer-motion";
import PageBanner from "../../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";

import "./iam.scss"
import sec2box1 from "../../../../../assets/website-images/product/iam/box/b1.png";
import sec2box2 from "../../../../../assets/website-images/product/iam/box/b2.png";
import sec2box3 from "../../../../../assets/website-images/product/iam/box/b3.png";
import sec2box4 from "../../../../../assets/website-images/product/iam/box/b4.png";
import sec2box5 from "../../../../../assets/website-images/product/iam/box/b5.png";
import sec3Img from "../../../../../assets/website-images/product/iam/sec3.png";
import {useTranslation} from "react-i18next";


export default function IAMPage() {
    const {t} = useTranslation();
    const ref3 = useRef(null);
    const ref = useRef(null);
    const isInView3 = useInView(ref3, { once: true });
    const isInView = useInView(ref, { once: true }); // Only trigger once
    const [activeSection, setActiveSection] = useState(1);
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };


    const handleSectionClick = (sectionIndex) => {
        setActiveSection(sectionIndex);
    };

    return(
        <div className={'iam-page product-pages'}>
            <PageBanner img={productPageImg} heading={t('products.id_solutions.banner_head')} bannerImg={productBannerImg}/>
            <div className={'section-1'}>
                <Container>
                    <Row>
                        <Col>
                            <h2 className={'heading mb-3'}>{t('products.id_solutions.head')}</h2>
                            <h5 className={'heading-h5 mb-3'}>{t('products.id_solutions.para_1')}</h5>
                            <p className={'pata'}> {t('products.id_solutions.para_2')}</p>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-2'}>
                <Container>
                    <Row>
                        <h3>{t('products.id_solutions.section_1.head')}</h3>
                    </Row>
                    <Row>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec2box1}/>
                                <h4>{t('products.id_solutions.section_1.box_1.head')}</h4>
                                <p>{t('products.id_solutions.section_1.box_1.para')}</p>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec2box2}/>
                                <h4>{t('products.id_solutions.section_1.box_2.head')}</h4>
                                <p>{t('products.id_solutions.section_1.box_2.para')}</p>
                            </div>

                        </Col>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec2box3}/>
                                <h4>{t('products.id_solutions.section_1.box_3.head')}</h4>
                                <p>{t('products.id_solutions.section_1.box_3.para')}</p>
                            </div>

                        </Col>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec2box4}/>
                                <h4>{t('products.id_solutions.section_1.box_4.head')}</h4>
                                <p>{t('products.id_solutions.section_1.box_4.para')}</p>
                            </div>

                        </Col>
                        <Col lg={4}>
                            <div className={'d-box'}>
                                <img src={sec2box5}/>
                                <h4>{t('products.id_solutions.section_1.box_5.head')}</h4>
                                <p>{t('products.id_solutions.section_1.box_5.para')}</p>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-3'}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <img src={sec3Img} className={'img-fluid mb-4'}/>
                        </Col>
                        <Col lg={6}>
                            <h2 className={'heading mb-4'}>{t('products.id_solutions.section_2.head')}</h2>
                            <p>{t('products.id_solutions.section_2.para_1')} </p>
                            <p>{t('products.id_solutions.section_2.para_2')} </p>
                            <p>{t('products.id_solutions.section_2.para_3')}</p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}